import React from 'react';
import LinkWithQuery from '../LinkWithQuery';
import CrmForm from '../CrmForm';
import TrustLogos from '../TrustLogos';

const Footer = () => {
	return (
		<footer className="c-footer">
			<div className="o-wrapper">
				<div className="c-footer__content">
					<div className="c-footer__content-col">
						<div className="o-row-2">
							<div className="c-footer__logo">
								<img
									className="o-fluid-img"
									src="https://res.cloudinary.com/dhqvlsb3l/image/upload/v1/assets/na/logos/hearcom-white.svg"
									alt="hear.com logo"
									loading="lazy"
								/>
							</div>
						</div>
						<div className="o-row-4 u-desktop-hidden">
							<a className="c-footer__phone track-cta-inbound-phone" href="tel:7865260602">
								(786) 526-0602
							</a>
						</div>
						<div className="o-row-4 u-text-center u-desktop-hidden">
							<div className="c-footer__separator"></div>
						</div>
						<div className="o-row-4 u-text-center u-desktop-hidden">
							<p className="c-crm-signup-copy">
								Curious about the cost of hearing aids?
								<br /> Get your <strong>free guide</strong> today:
							</p>
							<CrmForm />
							<p className="c-crm-signup-form-disc">
								By signing up to receive our guide, you'll be opted in to receive{' '}
								<span className="u-inline-block">marketing emails from hear.com</span>
							</p>
						</div>
						<div className="o-row-4 u-text-center u-desktop-hidden">
							<div className="c-footer__separator"></div>
						</div>
						<div className="o-row-2">
							<TrustLogos type="footer" />
						</div>
						<div className="o-row-4">
							<ul className="c-footer__nav">
								<li className="o-row">
									<LinkWithQuery className="c-footer-nav__link" to="/careers/">
										Careers
									</LinkWithQuery>
								</li>
								<li className="o-row">
									<LinkWithQuery className="c-footer-nav__link" to="/news/">
										Press
									</LinkWithQuery>
								</li>
								<li className="o-row">
									<a className="c-footer-nav__link" href="https://hear.com/become-a-partner/">
										Become a Partner Audiologist
									</a>
								</li>
								<li>
									<LinkWithQuery className="c-footer-nav__link" to="/contact/">
										Contact
									</LinkWithQuery>
								</li>
							</ul>
						</div>
						<div className="o-row-4 u-text-center-mobile">
							<div className="c-footer__separator"></div>
						</div>
						<div className="o-row-4 u-text-center-mobile">
							<ul className="c-footer__nav c-footer__nav--inline">
								<li className="o-row">
									<LinkWithQuery className="c-footer-nav__link" to="/privacy-policy/">
										Privacy Policy
									</LinkWithQuery>
								</li>
								<li className="o-row">
									<LinkWithQuery className="c-footer-nav__link" to="/hipaa-notice-of-privacy-practices/">
										HIPAA Notice of Privacy Practices
									</LinkWithQuery>
								</li>
								<li className="o-row">
									<LinkWithQuery className="c-footer-nav__link" to="/imprint/">
										Imprint
									</LinkWithQuery>
								</li>
								<li className="o-row">
									<LinkWithQuery className="c-footer-nav__link" to="/terms-and-conditions/">
										Terms &amp; Conditions
									</LinkWithQuery>
								</li>
								<li className="o-row">
									<LinkWithQuery className="c-footer-nav__link" to="/privacy-policy/" fragmentIdentifier="ad-choices">
										AdChoices
									</LinkWithQuery>
								</li>
								<li className="o-row">
									<LinkWithQuery className="c-footer-nav__link" to="/privacy-request/">
										Do Not Sell My Personal Information
										<span
											style={{
												fontSize: '75%',
												textAlign: 'center',
												display: 'block'
											}}
										>
											(CA Residents Only)
										</span>
									</LinkWithQuery>
								</li>
							</ul>
						</div>
						<div className="o-row-4 u-text-center u-desktop-hidden">
							<div className="c-footer__separator"></div>
						</div>
					</div>
					<div className="c-footer__content-col">
						<div className="o-row-4 u-mobile-hidden">
							<a className="c-footer__phone track-cta-inbound-phone" href="tel:7865260602">
								(786) 526-0602
							</a>
						</div>
						<div className="o-row-4 u-text-right u-mobile-hidden">
							<div className="c-footer__separator"></div>
						</div>
						<div className="o-row-4 u-mobile-hidden">
							<p className="c-crm-signup-copy">
								Curious about the cost of hearing aids?
								<br /> Get your <strong>free guide</strong> today:
							</p>
							<CrmForm />
							<p className="c-crm-signup-form-disc">
								By signing up to receive our guide, you'll be opted in to receive{' '}
								<span className="u-inline-block">marketing emails from hear.com</span>
							</p>
						</div>
						<div className="o-row-4 u-text-right u-mobile-hidden">
							<div className="c-footer__separator"></div>
						</div>
						<div className="o-row-4 u-text-center u-text-right-desk">
							<div className="c-social">
								<p className="c-social__label">Follow us:</p>
								<ul className="c-social__items">
									<li className="c-social__item">
										<a className="c-social__link" href="https://www.facebook.com/hearcom/" aria-label="Facebook">
											<img
												className="c-social__img o-fluid-img"
												src="https://res.cloudinary.com/dhqvlsb3l/image/upload/v1/assets/na/seo-website/icon-facebook.svg"
												alt=""
												loading="lazy"
											/>
										</a>
									</li>
									<li className="c-social__item">
										<a
											className="c-social__link"
											href="https://www.instagram.com/hear.com_official/"
											aria-label="Instagram"
										>
											<img
												className="c-social__img o-fluid-img"
												src="https://res.cloudinary.com/dhqvlsb3l/image/upload/v1/assets/na/seo-website/icon-instagram.svg"
												alt=""
												loading="lazy"
											/>
										</a>
									</li>
									<li className="c-social__item">
										<a
											className="c-social__link"
											href="https://www.pinterest.com/hearcom_official/"
											aria-label="Pinterest"
										>
											<img
												className="c-social__img o-fluid-img"
												src="https://res.cloudinary.com/dhqvlsb3l/image/upload/v1/assets/na/seo-website/icon-pinterest.svg"
												alt=""
												loading="lazy"
											/>
										</a>
									</li>
									<li className="c-social__item">
										<a
											className="c-social__link"
											href="https://www.linkedin.com/company/hear-com/"
											aria-label="Linkedin"
										>
											<img
												className="c-social__img o-fluid-img"
												src="https://res.cloudinary.com/dhqvlsb3l/image/upload/v1/assets/na/seo-website/icon-linkedin.svg"
												alt=""
												loading="lazy"
											/>
										</a>
									</li>
								</ul>
							</div>
						</div>
						<div className="o-row-4 u-text-center u-text-right-desk">
							<div className="c-footer__separator"></div>
						</div>
						<div className="c-flags u-text-center u-text-right-desk">
							<p className="c-flags__label">
								hear.com/audibene
								<br /> international:
							</p>
							<ul className="c-flags__items o-list-bare">
								<li className="c-flags__item">
									<a className="c-flags__link" href="https://www.audibene.de/">
										<img
											className="c-flags__img o-fluid-img"
											src="https://res.cloudinary.com/dhqvlsb3l/image/upload/v1/assets/na/seo-website/flag-de.jpg"
											alt="Germany flag"
											loading="lazy"
										/>
									</a>
								</li>
								<li className="c-flags__item">
									<a className="c-flags__link" href="https://www.audibene.fr/">
										<img
											className="c-flags__img o-fluid-img"
											src="https://res.cloudinary.com/dhqvlsb3l/image/upload/v1/assets/na/seo-website/flag-fr.jpg"
											alt="France flag"
											loading="lazy"
										/>
									</a>
								</li>
								<li className="c-flags__item">
									<a className="c-flags__link" href="https://www.hear.com/kr/">
										<img
											className="c-flags__img o-fluid-img"
											src="https://res.cloudinary.com/dhqvlsb3l/image/upload/v1/assets/na/seo-website/flag-kr.jpg"
											alt="Korea flag"
											loading="lazy"
										/>
									</a>
								</li>
								<li className="c-flags__item">
									<a className="c-flags__link" href="https://www.audibene.ch/">
										<img
											className="c-flags__img o-fluid-img"
											src="https://res.cloudinary.com/dhqvlsb3l/image/upload/v1/assets/na/seo-website/flag-su.jpg"
											alt="Switzerland flag"
											loading="lazy"
										/>
									</a>
								</li>
								<li className="c-flags__item">
									<a className="c-flags__link" href="https://www.audibene.nl/">
										<img
											className="c-flags__img o-fluid-img"
											src="https://res.cloudinary.com/dhqvlsb3l/image/upload/v1/assets/na/seo-website/flag-nl.jpg"
											alt="Netherlands flag"
											loading="lazy"
										/>
									</a>
								</li>
								<li className="c-flags__item">
									<a className="c-flags__link" href="https://www.hear.com/in/">
										<img
											className="c-flags__img o-fluid-img"
											src="https://res.cloudinary.com/dhqvlsb3l/image/upload/v1/assets/na/seo-website/flag-in.jpg"
											alt="India flag"
											loading="lazy"
										/>
									</a>
								</li>
								<li className="c-flags__item">
									<a className="c-flags__link" href="https://www.hear.com/za/">
										<img
											className="c-flags__img o-fluid-img"
											src="https://res.cloudinary.com/dhqvlsb3l/image/upload/v1/assets/na/seo-website/flag-za.png"
											alt="South Africa flag"
											loading="lazy"
										/>
									</a>
								</li>
							</ul>
						</div>
					</div>
				</div>
			</div>
		</footer>
	);
};

export default Footer;
